import { createRoot } from 'react-dom/client'
import ApplicationCenter from './ApplicationCenter'
import '../images/chevron_down.svg'
import '../images/arrow_right.svg'
import '../images/arrow_left.svg'
import '../images/plus.svg'
import '../images/minus.svg'
import '../images/edit.svg'

if (document.getElementById('root')) {
  const root = createRoot(document.getElementById('root'))
  root.render(<ApplicationCenter/>)
}
